import {useStyles} from '../../../shared/hooks/styles';

export default () =>
  useStyles(({theme}) => {
    return {
      container: {
        paddingHorizontal: 90,
        paddingTop: 20,
        marginBottom: 40,
        width: 934,
      },
      content: {
        paddingTop: 20,
      },
      title: {
        ...theme.fonts.h2,
      },
      buttonWrap: {
        marginTop: 25,
        marginBottom: 9,
        justifyContent: 'center',
        alignItems: 'center',
      },
      button: {
        width: 203,
      },
      time: {
        ...theme.fonts.body,
        color: theme.color.labelText,
        textAlign: 'right',
      },
      bodyText: {
        ...theme.fonts.h6Light,
        maxWidth: '100%',
      },
    };
  });
